import clsx from 'clsx';
import { Form, Formik } from 'formik';
import Link from 'next/link';
import React, { FC, useCallback, useMemo, useState } from 'react';

import { FormTextInput } from '../../base-components/FormTextInput';
import useModalState from '../_hooks/useModalState';
import { Modal } from '../_shared';
import { sendEmail } from '../_shared/sendEmailApi';
import styles from './Representatives.module.scss';
import { validationSchema } from './validationSchema';

export const Representatives: FC = () => {
    const initialValues = useMemo(
        () => ({
            surname: '',
            name: '',
            patronymic: '',
            email: '',
            phone: '',
            inn: '',
            company: '',
            title: 'Поступил запрос из раздела Партнёрство.',
            subject: 'Новая заявка на сотрудничество с сайта ЕСТП',
        }),
        []
    );

    const [isSuccessModalVisible, showSuccessModal, hideSuccessModal] =
        useModalState();
    const [successState, setSuccessState] = useState({
        header: 'Ошибка!',
        message: 'Что-то пошло не так. Пожалуйста, попробуйте еще раз',
    });

    const handleFormSubmit = useCallback(
        async (values, { resetForm }) => {
            try {
                await sendEmail({ ...values });

                setSuccessState({
                    header: 'Спасибо!',
                    message: 'Скоро мы с Вами свяжемся.',
                });
            } finally {
                showSuccessModal();
                resetForm();
            }
        },
        [showSuccessModal]
    );

    return (
        <>
            <div className={styles['floating-elements']}>
                <div className={styles['floating-element']}></div>
                <div className={styles['floating-element']}></div>
                <div className={styles['floating-element']}></div>
            </div>

            <div className={styles.container}>
                <div className={styles.header}>
                    <div className={styles.logo}>
                        <i className="fas fa-handshake"></i>
                    </div>
                    <h1 className={styles['h1']}>Уважаемые партнёры!</h1>
                    <p style={{ fontSize: '1.2rem', color: '#555' }}>
                        Компания ООО «ЕСТП» с радостью приглашает вас к
                        сотрудничеству в рамках программы лояльности
                    </p>
                </div>

                <div className={styles['widget-grid']}>
                    <div className={styles.widget}>
                        <div className={styles['widget-icon']}>
                            <i className="fas fa-bullseye"></i>
                        </div>
                        <h3>Наша цель</h3>
                        <p>
                            Объединение наших усилий позволит создать
                            эффективное партнёрство, выгодное для обеих сторон.
                        </p>
                    </div>

                    <div className={styles.widget}>
                        <div className={styles['widget-icon']}>
                            <i className="fas fa-chart-line"></i>
                        </div>
                        <h3>Ваша выгода</h3>
                        <p>
                            Станьте партнёром электронной торговой площадки
                            «ЕСТП» и привлекайте новых заказчиков на нашу
                            платформу.
                        </p>
                    </div>
                </div>

                <h2 className={styles['h2']}>
                    <i className="fas fa-gift"></i> Что мы предлагаем:
                </h2>
                <ul className={styles['feature-list']}>
                    <li>
                        <i className="fas fa-user-cog"></i> Гибкие условия
                        сотрудничества с индивидуальным подходом
                    </li>
                    <li>
                        <i className="fas fa-tools"></i> Необходимые для работы
                        материалы, информацию и поддержку для успешного
                        взаимодействия
                    </li>
                </ul>

                <h2 className={styles['h2']}>
                    <i className="fas fa-play-circle"></i> Как стать нашим
                    партнёром:
                </h2>
                <div className={styles['step-container']}>
                    <div className={styles.step}>
                        <div className={styles['step-number']}>
                            <a
                                href="#cooperation-form"
                                className={styles['step-link']}
                            >
                                1
                            </a>
                        </div>
                        <h3>Заполните форму</h3>
                        <p>
                            Заполните электронную форму по ссылке, указав
                            необходимые данные
                        </p>
                    </div>
                    <div className={styles.step}>
                        <div className={styles['step-number']}>2</div>
                        <h3>Рассмотрение заявки</h3>
                        <p>
                            Мы оперативно, в течение одного рабочего дня
                            рассмотрим вашу заявку
                        </p>
                    </div>
                    <div className={styles.step}>
                        <div className={styles['step-number']}>3</div>
                        <h3>Свяжемся с вами</h3>
                        <p>
                            После рассмотрения заявки мы свяжемся с вами для
                            дальнейших действий
                        </p>
                    </div>
                </div>

                <h2 className={styles['h2']}>
                    <i className="fas fa-star"></i> Преимущества участия в
                    программе лояльности
                </h2>
                <p>
                    Вы рекомендуете нас и выбираете один из вариантов
                    партнёрской программы:
                </p>

                <div className={styles['benefits-grid']}>
                    <div className={styles['benefit-card']}>
                        <div className={styles['benefit-icon']}>
                            <i className="fas fa-user-tie"></i>
                        </div>
                        <h3>Индивидуальные условия</h3>
                        <p>
                            Согласованные специально для вас условия
                            сотрудничества
                        </p>
                    </div>
                    <div className={styles['benefit-card']}>
                        <div className={styles['benefit-icon']}>
                            <i className="fas fa-gift"></i>
                        </div>
                        <h3>Подарочный сертификат</h3>
                        <div className={styles['brands-container']}>
                            <div className={styles['brand-item']}>
                                <img
                                    src="https://avatars.mds.yandex.net/i?id=c84a30d7dd0b9ee922de2fd67625495c57fdffe7-5221720-images-thumbs&n=13"
                                    alt="Ozon"
                                />
                            </div>
                            <div className={styles['brand-item']}>
                                <img
                                    src="https://yandex-images.clstorage.net/9FOq6E435/bcb13eh8r-/gbmlRmR2OSLy8vvqXYamdppm9Kb0BDxGP7tgAlhrUbOBewoFKbSmcGAu3U5MpXnPNpEal3NNHQUN1D7E2ZjdrpPg5AonNyB-rrjjpBGBr3KFLenu9EMgFDSse19calvY6g8pIUWdwAoXXqpVHLlo3lz6AupeX2pFSr8apsLKvMqUv5ljXERGPeXvkOt9kbNVpCvvitJjMhAGmT9YKxwfxeEAMiJ_nfUMJmCnZhXladtS6VLMS0dLY3CqC6DV44P8urejcUFifRrR9aPkdKW2QIEA_YbEQycSP48PQjccCuXEHRo1bJvDDhZxh3Ql9VjnYdNbyENCQmV8nDim9u6w3JqMmHd4dV8kxMWz_GSkiVSEPMKE2mo6KSa7J1YzDBnd5xcaDmKk9RAGW6xHMMBN2HvNQclkf3x_Qq4usdbbi9qDlrN0TEdWH_7GrdBWg6V3lxLUhNVSGAA-mhp_MAwA6PQLOiBxouIwFnaTfDDFWe9CxEncX0pKXVCtEr_Uzb_7j7q2a3B_UwL72aDDU6WQZLEC4K36SgIJJK8nYDM8B-XsHC4tcL3VKxFmhkU0zn39Rut43EN_XVVNjzeH9c2WyY2hhkh0RHEO5dCW1E2Al0KhJ9KIw0onDyS5BX4IOCPIxDw9GnSw6BsWdq9mP-ddzlDrR9ZXZXlUfKEvnOz9id6DnqVWUmxSPPvJt9BZpJB-lSLPpfdiBgARigpCKDk46PwBKQJAqNslKHWjfTHvYsV1wUvgQWVmZnSAKIHZ3ID0j72BX3hXcyv-0KTnRoSTVYYl74vJah0xPpgQaBU0KuPHBREXbIHKFBdwhU0MwmPASPFj9nN2Y31_hDy_0M6X-LK7vkFlU2Aj4_GB2V6Dk3mtGMuAyUQEGiWoDWACFj32_CUbBHS-3Q0jY7B5BOd82EnWQNtQZWh-fIwVm9nEsuqdgbJIRX9xJMXUoedZq4xaozzurPRNBBYarBx0BwI"
                                    alt="Wildberries"
                                />
                            </div>
                            <div className={styles['brand-item']}>
                                <img
                                    src="https://avatars.mds.yandex.net/i?id=27f97c49dbbe2f88d5cae5d1df65bbb4953665f3-16283842-images-thumbs&n=13"
                                    alt="РИВ ГОШ"
                                />
                            </div>
                            <div className={styles['brand-item']}>
                                <img
                                    src="https://avatars.mds.yandex.net/i?id=7f833e10742016a583425ffc148b2675dfb7d845-15443005-images-thumbs&n=13"
                                    alt="ЛЕТУАЛЬ"
                                />
                            </div>
                            <div className={styles['brand-item']}>
                                <img
                                    src="https://yandex-images.clstorage.net/9FOq6E435/bcb13eh8r-/gbmlRmR2OSLy8vvqXYamdppm9Kb0BDxGP7tgBFVoDbXReVhXKLCrIWJzh00epSLNZ5IWzHAZSAZYhmaQgp-G-c7u4gonNSB5obTnpRGBr3KFLenu9EMgFDSse1AMK1PpiH9bPEWT0wEPWLZlOt5U0mKLUNpOcQxzdZQZgcvyoMuOuohydWJfC9zAhOFPhodrozHrhcZIIDAElzpYMR0K7v8JHyFOnMgCNViDYwvgWeFr11HfQGJcVWCMOKfx57HNmZO3RFtqZRnB5r_Ge5y0ZKoF7pDjYzI8ErcvWggLOvTjCQoBa4HgFSZetWE78XnzW8dg43NYVVFoiTGh_dGCy7qehGR7UV4f-PGd-G6spHy6BNGE5l8NPgyeMmERPxLg5xkZOUiL4C4oYYN_K9tSwE7yddxpRk9QT7QPu8PjlNyaq79iYkt1HMzDlMNUr7pQiCP9p_VxGz4DphBICR4vyeQZAAxbl8AAO2eUXzv2bftO92HrUE9HRXSBOZnR4KjSmL2LQ25ncAPw-5HeUbC3Q40FyLTTYS8XLL4KQRMrEtbnKQcBQ4DUDTp4o0Q85njCSvxF-VRgdkVotC6RzMKN6rm9onFsfEAg9MCz0k-5gVSTIM-Sw0QdMhW-L0cTPTDI3C0jLGugxzo-dZ50O_ZR4UHVZcpCYElPfK4KkP3slfGgjb1mYkNjPtLokOBRoKBQhwTIrvdBAB8hlg5IJg4_9PwsOAxTndMiCm2tSgX1XfpP3VrBZ0pFeWquFaL1zZLslay0TG5gRzf407H3VLmzZ5gky4XkRiAxH54VeQkcJd7BISoHaJnrNyZEvHs68HvKcvBbxFp6bW9YvRC5_smG0py-o0BTZngp5dei_0mYllmAI8upz3sEOh-wDFISLDjW1gM9ElO54SQ-e6tiDuNO_nrVRNxbXU5Ce64buv3Br_aVtIZSfFx0IMX7s_hvvbZnhwvUisFfIRYiuQxeLSg"
                                    alt="золотое яблоко"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <h2 className={styles['h2']}>
                    <i className="fas fa-award"></i> Вознаграждение
                </h2>
                <p>
                    По итогам проведённых закупочных процедур с определением
                    победителя вы ежемесячно получаете вознаграждение или
                    выбранные сертификаты (сертификат = тарифицируемая
                    завершенная закупка).
                </p>

                <div className={styles['stats-widget']}>
                    <div className={styles['stat-item']}>
                        <div className={styles['stat-number']}>1=1</div>
                        <div className={styles['stat-label']}>
                            Закупка за сертификат
                        </div>
                    </div>
                    <div className={styles['stat-item']}>
                        <div className={styles['stat-number']}>100%</div>
                        <div className={styles['stat-label']}>
                            Сопровождение
                        </div>
                    </div>
                    <div className={styles['stat-item']}>
                        <div className={styles['stat-number']}>24/7</div>
                        <div className={styles['stat-label']}>Поддержка</div>
                    </div>
                </div>

                <div className={styles.widget}>
                    <div className={styles['widget-icon']}>
                        <i className="fas fa-user-shield"></i>
                    </div>
                    <h3>Полное сопровождение</h3>
                    <p>
                        Каждый приведённый вами заказчик получает полное
                        сопровождение закупок «под ключ» с личным менеджером.
                    </p>
                </div>

                <div className={styles['contact-info']}>
                    <h2 className={styles['h2']}>
                        <i className="fas fa-envelope"></i> Начните
                        сотрудничество сейчас!
                    </h2>

                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleFormSubmit}
                    >
                        {(formik) => (
                            <Form
                                id="cooperation-form"
                                className={styles['cooperation-form']}
                            >
                                <div className={styles['form-group']}>
                                    <div>
                                        <FormTextInput
                                            name="surname"
                                            appearance="default"
                                            label="Фамилия"
                                            required
                                            className={styles['form-input']}
                                        />
                                    </div>
                                    <div>
                                        <FormTextInput
                                            name="name"
                                            appearance="default"
                                            label="Имя"
                                            required
                                            className={styles['form-input']}
                                        />
                                    </div>
                                </div>

                                <div className={styles['form-group']}>
                                    <div>
                                        <FormTextInput
                                            name="patronymic"
                                            appearance="default"
                                            label="Отчество"
                                            className={styles['form-input']}
                                        />
                                    </div>
                                    <div>
                                        <FormTextInput
                                            name="email"
                                            appearance="default"
                                            label="E-mail"
                                            required
                                            className={styles['form-input']}
                                        />
                                    </div>
                                </div>

                                <div className={styles['form-group']}>
                                    <div>
                                        <FormTextInput
                                            name="phone"
                                            appearance="default"
                                            label="Телефон"
                                            required
                                            className={styles['form-input']}
                                        />
                                    </div>
                                    <div>
                                        <FormTextInput
                                            name="inn"
                                            appearance="default"
                                            label="ИНН"
                                            className={styles['form-input']}
                                        />
                                    </div>
                                </div>

                                <div className={styles['form-group']}>
                                    <div className="form-full-width">
                                        <FormTextInput
                                            name="company"
                                            appearance="default"
                                            label="Название компании"
                                            className={styles['form-input']}
                                        />
                                    </div>
                                </div>

                                <div className={styles['form-submit']}>
                                    <button
                                        type="submit"
                                        disabled={formik.isSubmitting}
                                        className={styles['cta-button']}
                                    >
                                        <i className="fas fa-paper-plane"></i>{' '}
                                        Отправить заявку
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>

                <div className={styles['footer-text']}>
                    <i
                        className="fas fa-heart"
                        style={{ color: '#e74c3c' }}
                    ></i>{' '}
                    Будем рады сотрудничеству с вами и дальнейшему взаимному
                    развитию!
                </div>
            </div>

            {isSuccessModalVisible && (
                <Modal
                    onHide={hideSuccessModal}
                    header={successState.header}
                    className={styles.responseModal}
                >
                    <p>{successState.message}</p>
                </Modal>
            )}
        </>
    );
};
